'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import { CTA_MOBILE, LanguageCTALinks } from '../../constants/TrialConstants';
import ResultHeaderIllustration from './ResultHeaderIllustration';
import ResultSection from './ResultSection';
import PageScore from '../PageScore';
import PreviewScreenshot from '../PreviewScreenshot';
import Subtitle from '../Subtitle';
import ScoreConstants from '../../constants/ScoreConstants';
import MobileData from '../../data/MobileData';
import ResultCtaBanner from '../ResultCtaBanner';
import phone from 'bender-url!../../../img/iphone-frame.png';
import { getMobilePreview } from '../../selectors/Preview';
import { parseUtmParams } from '../../util/Urls';
import usageTracker from '../../lib/usageTracker';
const CTAButton = /*#__PURE__*/memo(({
  websiteUrl
}) => {
  const lang = window.I18N_MANUAL_LANG;
  const isEn = lang === 'en';
  const alt = isEn ? '' : '-alt';
  const url = isEn ? CTA_MOBILE : LanguageCTALinks[lang];
  const parsedUtmParams = parseUtmParams();

  const handleClick = () => {
    const eventKey = isEn ? 'academyCourseClick' : 'freeGuideClick';
    const action = isEn ? 'clicked-free-lesson-link' : 'clicked-get-guide-link';
    usageTracker.log(eventKey, {
      action,
      websiteUrl,
      source: 'mobile-section'
    });
  };

  return /*#__PURE__*/_jsx(UILink, {
    href: `${url}&${parsedUtmParams}`,
    external: true,
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `results.mobile.cta.button${alt}`
    })
  });
});
export default (({
  websiteGrade,
  hideCTAs = false
}) => {
  const {
    url,
    error
  } = useSelector(getMobilePreview, shallowEqual); // Grade

  const grade = websiteGrade.mobileAudit.grade;
  const websiteUrl = websiteGrade.domain;
  return /*#__PURE__*/_jsx("div", {
    className: "full-page-centered mobile-page",
    id: "mobile",
    children: /*#__PURE__*/_jsx("div", {
      className: "flex-wrapper",
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx(ResultHeaderIllustration, {
          name: "mobile-onboarding-powering-up"
        }), /*#__PURE__*/_jsx(PageScore, {
          score: grade,
          overallScore: ScoreConstants.MOBILE_OVERALL
        }), /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.mobile.title"
          })
        }), /*#__PURE__*/_jsx(Subtitle, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.mobile.description"
          })
        }), !hideCTAs && /*#__PURE__*/_jsx(ResultCtaBanner, {
          use: "mobile",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "results.mobile.cta.info",
            options: {
              ctaButton: /*#__PURE__*/_jsx(CTAButton, {
                websiteUrl: websiteUrl
              })
            }
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "results-section",
          children: [/*#__PURE__*/_jsx(PreviewScreenshot, {
            backgroundUrl: phone,
            previewUrl: url,
            error: error,
            isMobile: true
          }), /*#__PURE__*/_jsx("div", {
            className: "bg-blob",
            children: /*#__PURE__*/_jsx("div", {
              className: "mobile-card-flow",
              children: /*#__PURE__*/_jsx(ResultSection, {
                websiteGrade: websiteGrade,
                results: MobileData.results
              })
            })
          })]
        })]
      })
    })
  });
});